import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/welcome';
import Cybersecurity from './topics/cybersecurity';
import TopicOcre from './topics/ocre';
import Topic1000 from './topics/iws';
import TopicPtm from './topics/ptm';
import TopicQuiz from './topics/topicQuiz';
import TopicOt from './topics/ot';
import './index.en.less';

export interface IGeneralStaffProps {
  topicName: string;
  topicSettings: any;
}

export function Education(props: IGeneralStaffProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/ocre"
        element={<TopicOcre settings={props.topicSettings} />}
      />
      <Route
        path="/iws"
        element={<Topic1000 settings={props.topicSettings} />}
      />
      <Route
        path="/ptm"
        element={<TopicPtm settings={props.topicSettings} />}
      />
      <Route path="/ot" element={<TopicOt settings={props.topicSettings} />} />
      <Route
        path="/cybersecurity"
        element={<Cybersecurity settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
